<div class="depot-page">

  <div class="page-header">
    <div class="page-header__info">
      <h1 class="page-header__title">
        <i class="fal fa-warehouse"></i>
        Dépôt & Tri
      </h1>
      <p class="page-header__sub">Gestion des colis au centre de dépôt, en tri et en transit</p>
    </div>
    <button class="btn-refresh" (click)="charger()" [disabled]="indicateurChargement">
      <i class="fal fa-sync" [class.fa-spin]="indicateurChargement"></i>
      Actualiser
    </button>
  </div>

  <!-- KPIs pipeline -->
  <div class="pipeline-bar" *ngIf="!indicateurChargement">
    <div class="pipeline-step" *ngFor="let s of STATUTS_DEPOT"
         [class.active]="s.valeur === statutFiltre"
         (click)="statutFiltre = s.valeur; appliquerFiltres()">
      <div class="pipeline-step__count">{{ compterParStatut(s.valeur) }}</div>
      <div class="pipeline-step__label">{{ s.libelle }}</div>
      <i class="fal fa-arrow-right pipeline-arrow"
         *ngIf="s.valeur !== STATUTS_DEPOT[STATUTS_DEPOT.length-1].valeur"></i>
    </div>
  </div>

  <!-- Filtres -->
  <div class="filtres-bar">
    <div class="filtre-search">
      <i class="fal fa-search"></i>
      <input type="text" [(ngModel)]="recherche" (ngModelChange)="appliquerFiltres()"
             placeholder="Référence, expéditeur, destinataire…" />
    </div>
    <select [(ngModel)]="statutFiltre" (ngModelChange)="appliquerFiltres()" class="filtre-select">
      <option *ngFor="let f of FILTRES" [value]="f.valeur">{{ f.libelle }}</option>
    </select>
  </div>

  <!-- Chargement -->
  <div class="etat-chargement" *ngIf="indicateurChargement">
    <div class="spinner"></div>
    <span>Chargement des colis au dépôt…</span>
  </div>

  <!-- Vide -->
  <div class="etat-vide" *ngIf="!indicateurChargement && commandesFiltrees.length === 0">
    <i class="fal fa-warehouse"></i>
    <p>Aucun colis dans ce statut.</p>
  </div>

  <!-- Cards dépôt -->
  <div class="depot-cards" *ngIf="!indicateurChargement && commandesFiltrees.length > 0">
    <div class="depot-card" *ngFor="let c of commandesFiltrees">
      <div class="depot-card__header">
        <span class="ref-badge">{{ c.numeroCommande ?? '#' + c.id }}</span>
        <span class="statut-badge" [ngClass]="badgeStatut(c.statut)">{{ libelleStatut(c.statut) }}</span>
      </div>
      <div class="depot-card__body">
        <div class="row-info">
          <i class="fal fa-user"></i>
          <span><strong>De :</strong> {{ c.expediteurNom ?? c.expediteur?.nom ?? '—' }}</span>
        </div>
        <div class="row-info">
          <i class="fal fa-user-tag"></i>
          <span><strong>À :</strong> {{ c.destinataireNom ?? c.destinataire?.nom ?? '—' }}</span>
        </div>
        <div class="row-info" *ngIf="c.trajet">
          <i class="fal fa-route"></i>
          <span>{{ c.trajet?.zoneDepart?.nom ?? '—' }} → {{ c.trajet?.zoneDestination?.nom ?? '—' }}</span>
        </div>
        <div class="row-info">
          <i class="fal fa-box"></i>
          <span>{{ c.typeEnvoi | titlecase }}</span>
          <strong class="montant">{{ (c.coutEstime ?? c.montantAPayer ?? 0) | number:'1.0-0' }} F</strong>
        </div>
      </div>
      <div class="depot-card__footer">
        <button class="btn-detail" (click)="voirDetail(c.id)">
          <i class="fal fa-eye"></i> Détail
        </button>
        <button class="btn-progresser" (click)="progresserStatut(c)"
                *ngIf="libelleProchainStatut(c.statut)">
          <i class="fal fa-forward"></i>
          {{ libelleProchainStatut(c.statut) }}
        </button>
        <span class="info-manifeste" *ngIf="infoStatut(c.statut)">
          <i class="fal fa-info-circle"></i> {{ infoStatut(c.statut) }}
        </span>
      </div>
    </div>
  </div>

</div>
